// extracted by mini-css-extract-plugin
export default {"root":"UserAvatar_root__qXUF+","avatar":"UserAvatar_avatar__ugIsW","avatarEdit":"UserAvatar_avatarEdit__F0ODY","avatarInput":"UserAvatar_avatarInput__WddLQ"};